<!-- Application Container -->
<div
    class="sb-layout"
    [style.--announcement-height.px]="announcementHeight()">
    <lib-announcement
        #announcementRef
        [announcementTitleTemplate]="announcement()?.announcementTitleTemplate()"
        [announcementTextTemplate]="announcement()?.announcementTextTemplate()"
        [announcementButtonGroupTemplate]="announcement()?.announcementButtonGroupTemplate()"></lib-announcement>

    <div class="sb-layout-body">
        <!-- Custom Sidebar -->
        <nav
            class="sb-sidebar"
            id="main-sidebar-navigation"
            aria-label="Main navigation"
            i18n-aria-label="@@CommonMainNavigation"
            #sidebarEl
            [class.sb-sidebar--open]="sideNavOpen()"
            [class.sb-sidebar--closing]="sideNavClosing()"
            [class.sb-sidebar--overlay]="isTouchScreenDevice"
            [hidden]="sideBarHidden">
            <!-- Sticky nav header -->
            <div class="sb-sidebar-header">
                @if (showLogo()) {
                    <lib-sidebar-logo>
                        <ng-content select="[schoolName]"></ng-content>
                    </lib-sidebar-logo>
                }
            </div>

            <!-- Nav links -->
            <div
                class="sb-sidebar-links"
                #sidebarLinks>
                <ng-template [ngTemplateOutlet]="links()"></ng-template>
                @if (overflowItems().length > 0) {
                    <lib-sidebar-overflow-item [items]="overflowItems()"></lib-sidebar-overflow-item>
                }
            </div>

            <!-- Sticky nav footer -->
            <div class="sb-sidebar-footer">
                <ng-content select="[navFooter]"></ng-content>
                @if (!isTouchScreenDevice) {
                    <lib-sidebar-item
                        [icon]="sideNavOpen() ? Icon.Common.DoubleArrowLeft : Icon.Common.DoubleArrowRight"
                        [navigationTitle]="sideNavOpen() ? 'Collapse' : 'Expand'"
                        [isAction]="true"
                        [expanded]="sideNavOpen()"
                        [controls]="'main-sidebar-navigation'"
                        (click)="ToggleSidenav()"></lib-sidebar-item>
                }
            </div>
        </nav>

        <!-- Mobile backdrop -->
        @if (isTouchScreenDevice && (sideNavOpen() || sideNavClosing())) {
            <div
                class="sb-sidebar-backdrop"
                (click)="OnSidenavClose()"></div>
        }

        <!-- Main Content -->
        <div
            class="sb-main"
            [class.sb-main--nav-open]="sideNavOpen() && !isTouchScreenDevice"
            [class.sb-main--overlay]="isTouchScreenDevice">
            <div class="sb-main-header">
                <lib-header>
                    @if (isTouchScreenDevice) {
                        <lib-icon-button
                            headerLeft
                            [icon]="Icon.Common.Menu"
                            ariaLabel="Toggle navigation"
                            i18n-ariaLabel="@@CommonToggleNavigation"
                            [ariaExpanded]="sideNavOpen()"
                            [kind]="ButtonKind.NeutralTertiary"
                            [size]="ButtonSize.Medium"
                            (clicked)="sideNavOpen() ? OnSidenavClose() : OnSidenavOpen()"></lib-icon-button>
                    }

                    <ng-container headerTitle>
                        @if (isMobile) {
                            <!-- Mobile: Text only -->
                            <h4 class="sb-main-header-title-mobile">
                                @if (showTitleWithTemplate()) {
                                    {{ currentHeaderTitle() }}
                                } @else if (!breadcrumbIsCollapsed()) {
                                    @if (currentHeaderBreadcrumb().length > 0) {
                                        {{ currentHeaderBreadcrumb()[0].label }}
                                    }
                                } @else {
                                    {{ breadcrumbFirst()!.label }}
                                }
                            </h4>
                        } @else {
                            <!-- Desktop: All breadcrumb items or title + template -->
                            <div
                                role="navigation"
                                aria-label="Breadcrumb"
                                i18n-aria-label="@@CommonBreadcrumbNavigation"
                                [ngClass]="{ 'sb-app-bar-breadcrumbs': isDesktop, 'sb-app-bar-breadcrumbs-mobile': isTablet }">
                                @if (showTitleWithTemplate()) {
                                    <!-- Title + Chevron + Template -->
                                    <div class="sb-app-bar-title-button">
                                        <lib-button
                                            [kind]="ButtonKind.NeutralLink"
                                            [size]="ButtonSize.XLarge">
                                            <ng-container label>{{ currentHeaderTitle() }}</ng-container>
                                        </lib-button>
                                    </div>
                                    <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
                                    <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                                        <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
                                    </div>
                                } @else if (currentHeaderBreadcrumb().length === 1 && Scope.currentBreadCrumbTemplateRef()) {
                                    <!-- 1 Breadcrumb + Template: Show icon > crumb > chevron > template -->
                                    @if (breadcrumbFirst()!.icon) {
                                        <div class="sb-app-bar-breadcrumb-icon-only-wrapper">
                                            <div class="sb-app-bar-breadcrumb-icon-only">
                                                <lib-icon
                                                    [icon]="breadcrumbFirst()!.icon ?? null"
                                                    [size]="IconSize.Medium"></lib-icon>
                                            </div>
                                        </div>
                                    }
                                    <div class="sb-app-bar-title-button">
                                        <lib-button
                                            [kind]="ButtonKind.NeutralLink"
                                            [size]="ButtonSize.XLarge"
                                            [isViewOnly]="true"
                                            [urlLink]="breadcrumbFirst()!.url"
                                            (clicked)="NavigateToBreadcrumb(breadcrumbFirst()!)">
                                            <ng-container label>{{ breadcrumbFirst()!.label }}</ng-container>
                                        </lib-button>
                                    </div>
                                    <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
                                    <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                                        <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
                                    </div>
                                } @else if (!(currentHeaderBreadcrumb().length === 1 && Scope.currentBreadCrumbTemplateRef())) {
                                    @if (!breadcrumbIsCollapsed() && !breadcrumbIsTabletCollapsed() && currentHeaderBreadcrumb().length > 1) {
                                        <div class="sb-app-bar-breadcrumb-icon">
                                            <lib-icon-button
                                                qaTag="$$ApplicationLayoutContainer_Breadcrumb_Previous_IconButton"
                                                [icon]="Icon.Common.ArrowBack"
                                                ariaLabel="Back to previous breadcrumb"
                                                i18n-ariaLabel="@@CommonBackToPreviousBreadcrumb"
                                                [kind]="ButtonKind.NeutralTertiary"
                                                [size]="ButtonSize.Large"
                                                (clicked)="NavigateToBreadcrumb(breadcrumbPrevious()!)"></lib-icon-button>
                                        </div>
                                    }
                                    @if (!breadcrumbIsCollapsed() && !breadcrumbIsTabletCollapsed()) {
                                        <ng-container *ngTemplateOutlet="expandedBreadcrumbs"></ng-container>
                                    } @else if (breadcrumbIsCollapsed() || breadcrumbIsTabletCollapsed()) {
                                        <div class="sb-app-bar-breadcrumb-icon">
                                            <lib-icon-button
                                                qaTag="$$ApplicationLayoutContainer_Breadcrumb_Previous_IconButton"
                                                [icon]="Icon.Common.ArrowBack"
                                                ariaLabel="Back to previous breadcrumb"
                                                i18n-ariaLabel="@@CommonBackToPreviousBreadcrumb"
                                                [kind]="ButtonKind.NeutralTertiary"
                                                [size]="ButtonSize.Large"
                                                (clicked)="NavigateToBreadcrumb(breadcrumbPrevious()!)"></lib-icon-button>
                                        </div>
                                        <ng-container *ngTemplateOutlet="collapsedBreadcrumbs"></ng-container>
                                    }
                                }
                            </div>
                        }
                    </ng-container>
                    <ng-container headerBelow>
                        @if (
                            isMobile &&
                            (showTitleWithTemplate() ||
                                (!breadcrumbIsMobileCollapsed() && currentHeaderBreadcrumb().length > 1) ||
                                breadcrumbIsMobileCollapsed() ||
                                (currentHeaderBreadcrumb().length === 1 && Scope.currentBreadCrumbTemplateRef()))
                        ) {
                            <!-- Mobile: Breadcrumb buttons below headerTitle -->
                            <div
                                class="sb-app-bar-breadcrumbs-mobile"
                                role="navigation"
                                aria-label="Breadcrumb"
                                i18n-aria-label="@@CommonBreadcrumbNavigation">
                                @if (!showTitleWithTemplate() && !(currentHeaderBreadcrumb().length === 1 && Scope.currentBreadCrumbTemplateRef())) {
                                    <div class="sb-app-bar-breadcrumb-icon">
                                        <lib-icon-button
                                            qaTag="$$ApplicationLayoutContainer_Breadcrumb_Previous_IconButton"
                                            [icon]="Icon.Common.ArrowBack"
                                            ariaLabel="Back to previous breadcrumb"
                                            i18n-ariaLabel="@@CommonBackToPreviousBreadcrumb"
                                            [kind]="ButtonKind.NeutralTertiary"
                                            [size]="ButtonSize.Large"
                                            (clicked)="NavigateToBreadcrumb(breadcrumbPrevious()!)"></lib-icon-button>
                                    </div>
                                }
                                @if (showTitleWithTemplate()) {
                                    <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
                                    <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                                        <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
                                    </div>
                                } @else if (currentHeaderBreadcrumb().length === 1 && Scope.currentBreadCrumbTemplateRef()) {
                                    <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                                        <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
                                    </div>
                                } @else if (!breadcrumbIsMobileCollapsed() && currentHeaderBreadcrumb().length > 1) {
                                    <ng-container *ngTemplateOutlet="expandedBreadcrumbsFromIndex"></ng-container>
                                } @else if (breadcrumbIsMobileCollapsed()) {
                                    <ng-container *ngTemplateOutlet="collapsedBreadcrumbsMobile"></ng-container>
                                }
                            </div>
                        }
                    </ng-container>
                    <ng-content
                        headerRight
                        #headerRight></ng-content>
                    @if (Scope.tabTemplateRef()) {
                        <ng-container *ngTemplateOutlet="Scope.tabTemplateRef()"></ng-container>
                    }
                </lib-header>
            </div>
            @if (currentHeaderTitle() || breadcrumbLast()?.label) {
                <h1 class="visually-hidden">{{ currentHeaderTitle() || breadcrumbLast()?.label }}</h1>
            }
            <section
                id="sb-application-layout-section"
                [ngClass]="{ 'padding-24': !isMobile, 'padding-16': isMobile }">
                <div [@routeAnimation]="{ value: routeAnimationState, params: { slideOffset: isMobile || isTablet ? 14 : 32, duration: isMobile || isTablet ? routeAnimationDuration / 2 : routeAnimationDuration } }">
                    <router-outlet (activate)="OnRouteActivate($event)"></router-outlet>
                </div>
            </section>
        </div>
    </div>
</div>

<!-- Breadcrumb Templates -->
<ng-template #chevronIcon>
    <div class="sb-app-bar-title-chevron" aria-hidden="true">
        <lib-icon
            [icon]="Icon.Common.ChevronRight"
            [size]="IconSize.Medium"></lib-icon>
    </div>
</ng-template>

<ng-template
    #breadcrumbButton
    let-crumb>
    <div class="sb-app-bar-title-button">
        <lib-button
            [kind]="ButtonKind.NeutralLink"
            [size]="ButtonSize.XLarge"
            [truncate]="true"
            [urlLink]="crumb?.url ?? ''"
            [qaTag]="crumb ? crumb.label + '-breadcrumb-button' : ''"
            (clicked)="NavigateToBreadcrumb(crumb)">
            <ng-container label>{{ crumb?.label }}</ng-container>
        </lib-button>
    </div>
</ng-template>

<ng-template #collapsedMenuButton>
    <div class="sb-app-bar-title-button">
        <lib-menu-button
            ariaLabel="More breadcrumbs"
            i18n-ariaLabel="@@CommonMoreBreadcrumbs"
            [kind]="ButtonKind.NeutralLink"
            [size]="ButtonSize.XLarge"
            [hasCaretSuffix]="false">
            <ng-container label>{{ '...' }}</ng-container>
            @for (crumb of breadcrumbMiddle(); track crumb.url) {
                <lib-menu-item
                    [label]="crumb.label"
                    [urlLink]="crumb.url"
                    (clicked)="NavigateToBreadcrumb(crumb)"></lib-menu-item>
            }
        </lib-menu-button>
    </div>
</ng-template>

<ng-template #lastBreadcrumb>
    @if (Scope.currentBreadCrumbTemplateRef()) {
        <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
            <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
        </div>
    } @else {
        <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
            <lib-button
                [kind]="ButtonKind.NeutralLink"
                [size]="ButtonSize.XLarge"
                [truncate]="true"
                [ariaCurrent]="'page'"
                    [isViewOnly]="true"
                [urlLink]="breadcrumbLast()!.url"
                (clicked)="NavigateToBreadcrumb(breadcrumbLast()!)">
                <ng-container label>{{ breadcrumbLast()!.label }}</ng-container>
            </lib-button>
        </div>
    }
</ng-template>

<ng-template #expandedBreadcrumbs>
    @if (currentHeaderBreadcrumb().length === 1 && !Scope.currentBreadCrumbTemplateRef()) {
        @if (breadcrumbFirst()!.icon) {
            <div class="sb-app-bar-breadcrumb-icon-only-wrapper">
                <div class="sb-app-bar-breadcrumb-icon-only">
                    <lib-icon
                        [icon]="breadcrumbFirst()!.icon ?? null"
                        [size]="IconSize.Medium"></lib-icon>
                </div>
            </div>
        }
    }
    @for (crumb of currentHeaderBreadcrumb(); track crumb.url) {
        @if ($last && Scope.currentBreadCrumbTemplateRef() && currentHeaderBreadcrumb().length > 1) {
            <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
            </div>
        } @else {
            <div [ngClass]="{ 'sb-app-bar-title-button': true, 'sb-app-bar-title-button--last': $last }">
                <lib-button
                    [kind]="ButtonKind.NeutralLink"
                    [size]="ButtonSize.XLarge"
                    [truncate]="true"
                    [ariaCurrent]="$last ? 'page' : null"
                        [isViewOnly]="$last"
                    [urlLink]="crumb?.url ?? ''"
                    [qaTag]="crumb ? crumb.label + '-breadcrumb-button' : ''"
                    (clicked)="NavigateToBreadcrumb(crumb)">
                    <ng-container label>{{ crumb?.label }}</ng-container>
                </lib-button>
            </div>
        }

        @if (!$last) {
            <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
        }
    }
    @if (Scope.currentBreadCrumbTemplateRef() && currentHeaderBreadcrumb().length === 1) {
        <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
        <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
            <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
        </div>
    }
</ng-template>

<ng-template #expandedBreadcrumbsFromIndex>
    @for (crumb of currentHeaderBreadcrumb(); track crumb.url; let idx = $index) {
        @if (idx > 0) {
            @if ($last && Scope.currentBreadCrumbTemplateRef() && currentHeaderBreadcrumb().length > 1) {
                <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
                    <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
                </div>
            } @else {
                <div [ngClass]="{ 'sb-app-bar-title-button': true, 'sb-app-bar-title-button--last': $last }">
                    <lib-button
                        [kind]="ButtonKind.NeutralLink"
                        [size]="ButtonSize.XLarge"
                        [truncate]="true"
                        [ariaCurrent]="$last ? 'page' : null"
                            [isViewOnly]="$last"
                        [urlLink]="crumb?.url ?? ''"
                        [qaTag]="crumb ? crumb.label + '-breadcrumb-button' : ''"
                        (clicked)="NavigateToBreadcrumb(crumb)">
                        <ng-container label>{{ crumb?.label }}</ng-container>
                    </lib-button>
                </div>
            }

            @if (!$last) {
                <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
            }
        }
    }
    @if (Scope.currentBreadCrumbTemplateRef() && currentHeaderBreadcrumb().length === 1) {
        <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
        <div class="sb-app-bar-title-button sb-app-bar-title-button--last">
            <ng-container *ngTemplateOutlet="Scope.currentBreadCrumbTemplateRef()"></ng-container>
        </div>
    }
</ng-template>

<ng-template #collapsedBreadcrumbs>
    <ng-container *ngTemplateOutlet="breadcrumbButton; context: { $implicit: breadcrumbFirst()! }"></ng-container>
    <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
    <ng-container *ngTemplateOutlet="collapsedMenuButton"></ng-container>
    <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
    <ng-container *ngTemplateOutlet="lastBreadcrumb"></ng-container>
</ng-template>

<ng-template #collapsedBreadcrumbsMobile>
    <ng-container *ngTemplateOutlet="collapsedMenuButton"></ng-container>

    @if (breadcrumbMiddle().length > 0) {
        <ng-container *ngTemplateOutlet="chevronIcon"></ng-container>
    }

    <ng-container *ngTemplateOutlet="lastBreadcrumb"></ng-container>
</ng-template>
